
import { Vue, Component, Ref } from 'vue-property-decorator';
import moment from 'moment';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import SelectAddressModal from './SelectAddressModal.vue';
import { CListByIds } from '@/models/supply.model';

// interface ProductItem {
//   materialCode: string;
//   productName: string;
//   specification: string;
//   quantityPerBox: number;
//   package_quantity: number;
//   pricePerPot: number;
//   goodsId: number;
// }

@Component({
  components: {
    SelectAddressModal,
  },
})
export default class PurchaseOrderCreateModal extends Vue {
  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  @Ref('selectAddressModal')
  selectAddressModal!: SelectAddressModal;

  visible = false;
  submitting = false;
  orderNo = '';
  orderDate: any = null;
  distributor: any = null;
  selectedAddress: any = null;
  productList: any = [];
  showAddProduct = false;
  // 类目相关
  categoryList: any[] = [];
  subCategoryList: any[] = [];
  selectedCategoryId: number | undefined = undefined;
  selectedSubCategoryId: number | undefined = undefined;
  // 搜索相关
  searchKeyword = '';
  searchGoodsList: any[] = [];
  searchLoading = false;
  addProductLoading = false;
  // 选中商品
  selectedGoodsKeys: number[] = [];
  selectedGoodsRecords: any[] = [];

  addProductColumns = [
    {
      title: '产品名称',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '单价',
      dataIndex: 'plat_agent_price',
      align: 'center',
    },
  ];

  productColumns = [
    {
      title: '物料编码',
      dataIndex: 'commodity_code',
      align: 'center',
    },
    {
      title: '产品名称',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '规格',
      dataIndex: 'product_attributes',
      align: 'center',
      customRender: (text: any, record: any) => {
        return record.product_attributes.pkg_spec || '';
      },
    },
    {
      title: '数量/箱',
      dataIndex: 'packageQuantity',
      align: 'center',
    },
    {
      title: '下单箱数',
      dataIndex: 'package_quantity',
      align: 'center',
      scopedSlots: { customRender: 'package_quantity' },
    },
    {
      title: '下单壶数',
      dataIndex: 'orderPots',
      align: 'center',
      scopedSlots: { customRender: 'orderPots' },
    },
    {
      title: '单价/壶',
      dataIndex: 'plat_agent_price',
      align: 'center',
      scopedSlots: { customRender: 'pricePerPot' },
    },
    {
      title: '小计（元）',
      dataIndex: 'subtotal',
      align: 'center',
      scopedSlots: { customRender: 'subtotal' },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      width: 80,
      scopedSlots: { customRender: 'action' },
    },
  ];

  get totalBoxes() {
    return this.productList.reduce(
      (sum: number, item: any) => sum + (item.package_quantity || 0),
      0,
    );
  }

  get totalPots() {
    return this.productList.reduce(
      (sum: number, item: any) =>
        sum + (item.quantity || 0),
      0,
    );
  }

  get totalAmount() {
    return this.productList
      .reduce((sum: number, item: any) => {
        const price = (item.quantity || 0);
        const pots = price * (item.plat_agent_price || 0);
        return sum + pots;
      }, 0)
      .toFixed(2);
  }

  calcSubtotal(record: any) {
    const pots = (+record.quantity || 0) * (+record.plat_agent_price || 0);
    return pots.toFixed(2);
  }

  onProductChange(index: number) {
    const record = this.productList[index];
    if (record) {
      record.quantity = (+record.package_quantity || 0) * (+record.packageQuantity || 0);
    }
    // 触发响应式更新
    console.log(index);
    this.productList = [...this.productList];
  }

  formatFullAddress(record: any) {
    if (!record) return '';
    const region = [record.province, record.city, record.district]
      .filter(Boolean)
      .join('');
    return `${region}${record.address || ''}`;
  }

  openSelectAddress() {
    if (!this.distributor || !this.distributor.id) {
      this.$message.warning('请先选择经销商');
      return;
    }
    this.selectAddressModal.open(this.distributor.id);
  }

  onAddressSelect(address: any) {
    this.selectedAddress = address;
  }

  removeProduct(index: number) {
    this.productList.splice(index, 1);
  }

  onGoodsSelectChange(selectedRowKeys: number[], selectedRows: any[]) {
    this.selectedGoodsKeys = selectedRowKeys;
    this.selectedGoodsRecords = selectedRows || [];
  }

  async onCategoryChange(value: number) {
    this.selectedSubCategoryId = undefined;
    this.subCategoryList = [];
    this.searchGoodsList = [];
    this.selectedGoodsKeys = [];
    this.selectedGoodsRecords = [];
    if (!value) return;
    try {
      // const res = await this.supplyService.getGoodsSubCategoryList(value);
      // this.subCategoryList = (res as any) || [];
    } catch (e) {
      this.subCategoryList = [];
    }
  }

  onAddProduct() {
    this.showAddProduct = true;
    this.onSearchGoods();
  }

  onSubCategoryChange() {
    this.searchGoodsList = [];
    this.selectedGoodsKeys = [];
    this.selectedGoodsRecords = [];
  }
  async onSearchGoods() {
    try {
      const res = await this.supplyService.getCommodityListByCategory({
        distributor_id: this.distributor.id,
        pid: '1',
        category_id: '2',
      });
      const list = Array.isArray(res) ? res : (res && res.list) || [];
      this.searchGoodsList = list;
      // 保留已选中且仍在结果集中的行
      const idSet = new Set(list.map((it: any) => it.id));
      this.selectedGoodsKeys = this.selectedGoodsKeys.filter(
        (id) => idSet.has(id),
        // eslint-disable-next-line function-paren-newline
      );
      this.selectedGoodsRecords = this.selectedGoodsRecords.filter(
        (r) => idSet.has(r.id),
        // eslint-disable-next-line function-paren-newline
      );
    } catch (e) {
      this.searchGoodsList = [];
    } finally {
      this.searchLoading = false;
    }
  }

  onResetSearch() {
    this.selectedCategoryId = undefined;
    this.selectedSubCategoryId = undefined;
    this.subCategoryList = [];
    this.searchKeyword = '';
    this.searchGoodsList = [];
    this.selectedGoodsKeys = [];
    this.selectedGoodsRecords = [];
  }

  async onAddProductConfirm() {
    if (!this.selectedGoodsKeys.length) {
      this.$message.warning('请至少选择一个商品');
      return;
    }
    this.addProductLoading = true;
    try {
      const res = await this.supplyService.getCommodityListByIds({
        ids: this.selectedGoodsKeys.join(','),
        distributor_id: this.distributor.id,
      });
      const items = res.map((it: any) => CListByIds.from(it));
      const details: any[] = items || [];
      if (!details.length) {
        this.$message.warning('未获取到商品详情');
        return;
      }
      let addedCount = 0;
      details.forEach((goods: any) => {
        if (this.productList.some((item: any) => item.commodity_id === goods.commodity_id)) {
          return;
        }
        this.productList.push({ ...goods, package_quantity: 1, quantity: 1 * goods.packageQuantity || 0 });
        addedCount++;
      });
      if (addedCount > 0) {
        this.$message.success(`已添加 ${addedCount} 件商品`);
      } else {
        this.$message.warning('所选商品均已在列表中');
      }
      this.onAddProductCancel();
    } finally {
      this.addProductLoading = false;
    }
  }

  onAddProductCancel() {
    this.showAddProduct = false;
    this.selectedCategoryId = undefined;
    this.selectedSubCategoryId = undefined;
    this.subCategoryList = [];
    this.searchKeyword = '';
    this.searchGoodsList = [];
    this.selectedGoodsKeys = [];
    this.selectedGoodsRecords = [];
  }

  async open(distributor?: any) {
    this.visible = true;
    this.distributor = distributor || null;
    this.orderDate = moment();
    console.log('open', distributor);
    this.productList = [];
    if (this.distributor) {
      await this.loadOrderNo();
      await this.loadDistributor();
    }
    await this.loadCategoryList();
  }

  async loadOrderNo() {
    const res =
      await this.supplyService.getDistributorPurchaseOrderGenerateOrderNo({
        distributor_id: this.distributor.id,
      });
    this.orderNo =
      typeof res === 'string'
        ? res
        : (res && (res.order_no || res.orderNo)) || '';
  }

  async loadDistributor() {
    const res = await this.supplyService.postDistributorDelivery(this.distributor.id);
    // console.log(res);
    this.selectedAddress = res;
  }

  async loadCategoryList() {
    // try {
    //   const res = await this.supplyService.getGoodsCategoryList();
    //   this.categoryList = (res as any) || [];
    // } catch (e) {
    //   this.categoryList = [];
    // }
  }

  async onSubmit() {
    if (this.productList.length === 0) {
      this.$message.warning('请至少添加一个商品');
      return;
    }
    const params = {
      orderNo: this.orderNo,
      orderDate: this.orderDate.format('YYYY-MM-DD'),
      distributor_id: this.distributor.id,
      commodities: this.productList,
      package_quantity: this.totalBoxes,
      quantity: this.totalPots,
      amount: this.totalAmount,
      distributor_delivery_id: this.selectedAddress && this.selectedAddress.id,
    };
    this.submitting = true;
    try {
      // TODO: 调用创建采购单接口
      const res = await this.supplyService.postDistributorPurchaseOrderAdd(
        params,
      );
      if (res) {
        this.$message.success('创建成功');
        this.$emit('refresh');
        this.onClose();
      }
    } catch (e) {
      this.$message.error('创建失败');
    }
  }

  onClose() {
    this.visible = false;
    this.orderNo = '';
    this.orderDate = null;
    this.distributor = null;
    this.selectedAddress = null;
    this.productList = [];
    this.showAddProduct = false;
    this.selectedCategoryId = undefined;
    this.selectedSubCategoryId = undefined;
    this.subCategoryList = [];
    this.searchKeyword = '';
    this.searchGoodsList = [];
    this.selectedGoodsKeys = [];
    this.selectedGoodsRecords = [];
    this.submitting = false;
  }
}
